import script from "./BookConsultation.vue?vue&type=script&setup=true&lang=js"
export * from "./BookConsultation.vue?vue&type=script&setup=true&lang=js"

import "./BookConsultation.vue?vue&type=style&index=0&id=d14481c8&lang=scss"

const __exports__ = script;

export default __exports__